<div class="mustTurn">
  <img src="/img/deco/refresh-ccw.svg" alt="">
  <p class="font-cinzel">Tournez votre écran</p>
</div>

<style lang="scss">
	@import "../scss/variables.scss";

	.mustTurn {
		background-color: black;
		width: 100%;
		height: 100%;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		position: fixed;
		z-index: 90;
		
		img {
			width: 123px;
		}

		p {
			color: $main-color;
			font-size: 24px;
		}
	}
</style>